
import { defineComponent } from "@vue/runtime-core";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getState } from "@/pinia/AppState";

import * as Lang from "../../i18n/lang";
import { LoginViewType } from "@/views/LoginViewType";

export default defineComponent({
  data() {
    return { Lang: Lang };
  },
  unmounted() {
    document.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
    let userEmail = getState().initialEmail;
    if (userEmail !== null) {
      (this.$refs.email as any).setValue(userEmail);
    }
  },
  methods: {
    async onKeyDown(event: any) {
      if (event.key === "Enter") {
        await this.login();
      }
    },
    openLostPass() {
      (this.$parent as any).switchView(LoginViewType.LostPassword);
    },
    openRegister() {
      console.log("test");
      (this.$parent as any).switchView(LoginViewType.Registration);
    },
    async login() {
      let email = (this.$refs.email as any).getValue().toLowerCase();

      let password = (this.$refs.password as any).getValue();

      let stateLabel: HTMLElement = this.$refs.stateLabel as HTMLElement;

      const auth = getAuth();

      try {
        await signInWithEmailAndPassword(auth, email, password);
      } catch (error: any) {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
        stateLabel.style.display = "";
      }
    },
  },
});
